import React from 'react'

import classNames from 'classnames'
import { CLASS_PREFIX } from 'src/constants'
import './detail_card.scss'

const cls = `${CLASS_PREFIX}project-detail-card`

type Props = {
  withPadding?: boolean;
};

export const DetailCard: React.FC<Props> = ({ children, withPadding }) => {
  return (
    <div
      className={classNames(cls, {
        [`${cls}__with-padding`]: withPadding,
        [`${cls}__without-padding`]: withPadding === false
      })}
    >
      {children}
    </div>
  )
}
